// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"1a589a981484946ddcc0","678":"7347af4f709e1c950f83","883":"022b98653081ae7b3a60"}[chunkId] + ".js";
};